import { useMemo } from 'react'

import { useUserData } from '@web-app/context/UserDataContext'

import { maxSeverity, resolveAttention } from './attention'

// Open issues off the app-wide data, worst first.
export function useAttention() {
  const { paymentAccounts, membership } = useUserData()
  return useMemo(() => {
    const issues = resolveAttention({ paymentAccounts, membership })
    return { issues, severity: maxSeverity(issues) }
  }, [paymentAccounts, membership])
}
